export { default } from './RedPagosAlert';